export type TrendDirection = 'up' | 'down' | 'flat';

export interface Trend {
  direction: TrendDirection;
  label: string;
}

export const NEW_THIS_PERIOD = 'New this period';

const NO_CHANGE: Trend = { direction: 'flat', label: 'No change' };

export function describeTrend(current: number, previous: number): Trend {
  if (previous === 0) {
    return current === 0 ? NO_CHANGE : { direction: 'up', label: NEW_THIS_PERIOD };
  }
  const change = Math.round(((current - previous) / previous) * 100);
  if (change === 0) return NO_CHANGE;
  if (change > 0) return { direction: 'up', label: `+${change}%` };
  return { direction: 'down', label: `${change}%` };
}
